import _ from 'lodash'
import type {CreateExtArgs} from '@wix/document-manager-core'
import type {CompRef, Pointer} from '@wix/document-services-types'
import type {SchemaExtensionAPI} from '../../../schema/schema'
import type {SlotsExtensionAPI} from '../../../slots/slots'

const BLOCKS_HOST_COMPONENT_TYPE = 'wysiwyg.viewer.components.RefComponent'
const BLOCKS_DEFAULT_SLOT_ROLE = 'slot'

const cleanupCompsInSlots = (createExtArgs: CreateExtArgs, compPointer?: Pointer | null): void => {
    if (!compPointer) {
        return
    }

    const {dal, pointers, extensionAPI} = createExtArgs
    const {schemaAPI} = extensionAPI as SchemaExtensionAPI
    const {slots} = extensionAPI as SlotsExtensionAPI

    let hostComp
    const parentPointer = pointers.structure.getParent(compPointer)

    if (parentPointer) {
        hostComp = dal.get(parentPointer)
    }

    if (parentPointer && hostComp?.componentType && hostComp.slotsQuery) {
        if (schemaAPI.isSchemaCollectionRegistered(hostComp.componentType)) {
            return
        }

        const slotsData = slots.getSlotsData(parentPointer as CompRef)

        if (!_.isEmpty(slotsData)) {
            for (const slotRole in slotsData) {
                if (slotsData[slotRole].id === compPointer.id) {
                    slots.remove(parentPointer as CompRef, slotRole, true)
                    return
                }
            }
        }
    }

    if (hostComp?.componentType === BLOCKS_HOST_COMPONENT_TYPE) {
        const slotPlaceholderPointer = slots.getPluginParent(compPointer as CompRef)

        if (slotPlaceholderPointer) {
            slots.remove(slotPlaceholderPointer, BLOCKS_DEFAULT_SLOT_ROLE, true)
        }
    }
}

export const cleanupCompsInSlotsInRemoval = (
    createExtArgs: CreateExtArgs,
    compPointer: Pointer | null | undefined,
    deletingParent: boolean
): void => {
    if (deletingParent) {
        return
    }

    return cleanupCompsInSlots(createExtArgs, compPointer)
}
